<template>
  <div class="cmodal h-card shadow" v-if="!$store.state.loading">
    <div class="card-header" >
      <h5 class="modal-title">Подтвердите бронирование</h5>
      <button type="button" @click="closeCmodal" class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
    </div>
    <div class="card-body">
        Нажмите кнопку "Забронировать" для подтверждения бронирования.
    </div>
    <div class="card-footer">
      <button class="ok-btn" @click="sendBooking">Забронировать</button>
    </div>
  </div>
</template>
<script>
import {popModal} from "jenesius-vue-modal";

export default {
  name: 'MessageModalBooking',
  data() {
    return {
    }
  },
  created() {
  },
  computed: {

  },
  methods:{
    sendBooking(){

      this.$emitter.emit('send_booking')
      this.$emitter.emit('resetMemoryDataSelected')
      this.closeCmodal();
    },
    closeCmodal(){
      popModal();
    },
  }
}
</script>
<style scoped>
.cmodal {
  max-width: 460px;
}
.cmodal textarea{
  border-radius: .3em;
}
.cmodal .card-header{
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  background: #ff923180;
}

.cmodal label{
  margin-bottom: 0.1rem;
  font-size: 0.85rem;
  color: #ad8b57;
}

.cmodal .hint{
  margin-top: 0.1rem;
  font-size: .75em;
  color:#999;
}
.cmodal  .card-body {
  overflow: auto;
  //height: 400px;
  height: fit-content;
  max-height: 95vh;
}
</style>